/**
 * Created by Juno Peng 2/18/2024
 * Description:
 * CentralConfig model
 * ------ maintenance history ------
 */

export class CentralConfig {

    host: '';
    port: '';
    SSL = false;
    refdatasourceHost: '';
    refdatasourcePort: '';
    refdatasourceUsername: '';
    refdatasourcePassword: '';
    currentReferenceDataVersion: '';
    refdataDataSet: { stringValue: '', type: 0 };
    connectionRetries: 0;
    refdataSSL = false;
    initialLoad = false;

    static parse(res): CentralConfig {
        const centralConfig = new CentralConfig();
        centralConfig.host = res['host'];
        centralConfig.port = res['port'];
        centralConfig.SSL = res['SSL'];
        centralConfig.refdatasourceHost = res['refdatasourceHost'];
        centralConfig.refdatasourcePort = res['refdatasourcePort'];
        centralConfig.refdatasourceUsername = res['refdatasourceUsername'];
        centralConfig.refdatasourcePassword = res['refdatasourcePassword'];
        centralConfig.currentReferenceDataVersion = res['currentReferenceDataVersion'];
        centralConfig.refdataDataSet = res['refdataDataSet'];
        centralConfig.connectionRetries = res['connectionRetries'];
        centralConfig.refdataSSL = res['refdataSSL'];
        centralConfig.initialLoad = res['initialLoad'];
        return centralConfig;
    }
}
